// extracted by mini-css-extract-plugin
export default {"container":"GvA9292W","markdown":"g2GbAQo3"};